export default {"src":"https://webcdn.trailways.com/_next/static/media/twitter.c206519e.svg","height":20,"width":25,"blurWidth":0,"blurHeight":0};